// extracted by mini-css-extract-plugin
export default {"wrapper":"Nav_wrapper__slpzq"};